<div id="config-container">

    <div id="controller-config-header" class="row">

        <div class="col-xs-12 config-header-info-row">
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Controller Id: </span><span>{{ controllerInfo?.ControllerId || '---' }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Controller UId: </span><span>{{ controllerInfo?.ControllerUId || '---' }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Controller Name: </span><span>{{ controllerInfo?.ControllerName || '---' }}</span>
            </div>
        </div>

        <div class="col-xs-12 config-header-info-row">
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Gateway: </span><span>{{ controllerInfo?.GatewayName || '---' }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Gateway UId: </span><span>{{ controllerInfo?.GatewayUId || '---' }}</span>
            </div>
        </div>

        <div class="col-xs-12 config-header-info-row">
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">APAN: </span><span>{{ controllerInfo?.Apan || '---' }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Communication PIN: </span><span>{{ controllerInfo?.CommunicationPIN || '---' }}</span>
            </div>
        </div>

        <div class="col-xs-12 config-header-info-row">
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Smart Connect Id: </span><span>{{ controllerInfo?.SmartConnectId || '---' }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <span class="config-header-label">Comm Card UId: </span><span>{{ controllerInfo?.CommCardUId || '---' }}</span>
            </div>
        </div>

    </div>

    <ngx-json-viewer [json]="data.IncomingConfiguration" [expanded]="false"></ngx-json-viewer>
</div>
